import "core-js/features/array/flat";
import {
  FACILITY_AMBULATORY_ASSISTED_COMMUNITY,
  FACILITY_AMBULATORY_ASSISTED_LIVING,
  FACILITY_AMBULATORY_PSYCHIATRIC_CARE,
  FACILITY_AMBULATORY_PSYCHIATRIC_REHAB,
  FACILITY_ASSISTED_LIVING,
  FACILITY_COMPANIONSHIP,
  FACILITY_DAILY_LIVING_SUPPORT_SERVICES,
  FACILITY_DAY_CARE,
  FACILITY_DAY_CARE_CENTRE,
  FACILITY_DAY_HOSPITALIZATION,
  FACILITY_FULLTIME_COMPANIONSHIP,
  FACILITY_FULLTIME_MOBILE_CARE,
  FACILITY_FULL_HOSPITALIZATION,
  FACILITY_GERONTOPSYCHIATRIC_DAY_CLINIC,
  FACILITY_HOME_CARE,
  FACILITY_HOSPICE_ASSOCIATION,
  FACILITY_HOSPICE_MOBILE,
  FACILITY_HOSPICE_PARTIALLY_MOBILE,
  FACILITY_HOSPICE_STATIC,
  FACILITY_INTENSIVE_PSYCHIATRIC_CARE_HOME,
  FACILITY_LONGTERM_PSYCHIATRIC_CARE,
  FACILITY_MEDICAL_OCCUPATIONAL_REHAB,
  FACILITY_MEDICAL_SUPPLIES,
  FACILITY_MOBILE_CARE,
  FACILITY_NIGHT_CARE_MOBILE,
  FACILITY_NIGHT_CARE_STATIC,
  FACILITY_PSYCHIATRIC_DAY_CLINIC,
  FACILITY_REHAB_DAY_HOSPITALIZATION,
  FACILITY_REHAB_FULL_HOSPITALIZATION,
  FACILITY_REHAB_MOBILE,
  FACILITY_SHARED_FLAT,
  FACILITY_SHORT_TERM_CARE,
  FACILITY_SHORT_TERM_CARE_PSYCHIATRIC,
  FACILITY_SPECIAL_LIVING_ARRANGEMENTS_ADDICTIONS,
  FACILITY_SPECIAL_LIVING_ARRANGEMENTS_INTELLECTUAL,
  FACILITY_SPECIAL_LIVING_ARRANGEMENTS_PSYCHIATRIC,
  FACILITY_STATIC_CARE,
  FACILITY_STATIONARY_PSYCHIATRIC_REHAB,
  FACILITY_WFBM,
  SOLUTION_AMBULATORY_ASSISTED_COMMUNITY,
  SOLUTION_AMBULATORY_ASSISTED_LIVING,
  SOLUTION_AMBULATORY_PSYCHIATRIC_CARE,
  SOLUTION_AMBULATORY_PSYCHIATRIC_REHAB,
  SOLUTION_ASSISTED_LIVING,
  SOLUTION_DAILY_LIVING_SUPPORT_SERVICES,
  SOLUTION_DAY_CARE,
  SOLUTION_DAY_CARE_CENTRE,
  SOLUTION_DAY_HOSPITALIZATION,
  SOLUTION_FULL_HOSPITALIZATION,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  SOLUTION_GERONTOPSYCHIATRIC_DAY_CLINIC,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_HOME_CARE,
  SOLUTION_HOSPICE_ASSOCIATION,
  SOLUTION_HOSPICE_MOBILE,
  SOLUTION_HOSPICE_PARTIALLY_MOBILE,
  SOLUTION_HOSPICE_STATIC,
  SOLUTION_INTENSIVE_PSYCHIATRIC_CARE_HOME,
  SOLUTION_LONGTERM_PSYCHIATRIC_CARE,
  SOLUTION_MEDICAL_OCCUPATIONAL_REHAB,
  SOLUTION_MEDICAL_SUPPLIES,
  SOLUTION_MOBILE_CARE,
  SOLUTION_NIGHT_CARE_MOBILE,
  SOLUTION_NIGHT_CARE_STATIC,
  SOLUTION_PSYCHIATRIC_DAY_CLINIC,
  SOLUTION_REHAB_DAY_HOSPITALIZATION,
  SOLUTION_REHAB_FULL_HOSPITALIZATION,
  SOLUTION_REHAB_MOBILE,
  SOLUTION_SHARED_FLAT,
  SOLUTION_SHORT_TERM_CARE_PSYCHIATRIC,
  SOLUTION_SHORT_TERM_STATIC_CARE,
  SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_ADDICTIONS,
  SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_INTELLECTUAL,
  SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_PSYCHIATRIC,
  SOLUTION_STATIC_CARE,
  SOLUTION_STATIONARY_PSYCHIATRIC_REHAB,
  SOLUTION_WFBM,
} from "core/consts";
import { activateSolutionToServiceMigration } from "core/model/utils/featureFlags";

const solutionFacilitiesMap: { [key: number]: Array<number> } = {
  [SOLUTION_AMBULATORY_ASSISTED_COMMUNITY]: [
    FACILITY_AMBULATORY_ASSISTED_COMMUNITY,
  ],
  [SOLUTION_AMBULATORY_ASSISTED_LIVING]: [FACILITY_AMBULATORY_ASSISTED_LIVING],
  [SOLUTION_AMBULATORY_PSYCHIATRIC_CARE]: [FACILITY_AMBULATORY_PSYCHIATRIC_CARE],
  [SOLUTION_AMBULATORY_PSYCHIATRIC_REHAB]: [
    FACILITY_AMBULATORY_PSYCHIATRIC_REHAB,
  ],
  [SOLUTION_ASSISTED_LIVING]: [FACILITY_ASSISTED_LIVING],
  [SOLUTION_DAILY_LIVING_SUPPORT_SERVICES]: [
    FACILITY_DAILY_LIVING_SUPPORT_SERVICES,
  ],
  [SOLUTION_DAY_CARE]: [FACILITY_DAY_CARE],
  [SOLUTION_DAY_CARE_CENTRE]: [FACILITY_DAY_CARE_CENTRE],
  [SOLUTION_DAY_HOSPITALIZATION]: [FACILITY_DAY_HOSPITALIZATION],
  [SOLUTION_FULL_HOSPITALIZATION]: [FACILITY_FULL_HOSPITALIZATION],
  [SOLUTION_FULL_TIME_MOBILE_CARE]: [
    FACILITY_FULLTIME_MOBILE_CARE,
    FACILITY_FULLTIME_COMPANIONSHIP,
  ],
  [SOLUTION_GERONTOPSYCHIATRIC_DAY_CLINIC]: [
    FACILITY_GERONTOPSYCHIATRIC_DAY_CLINIC,
  ],
  [SOLUTION_HELP_AT_HOME]: [FACILITY_COMPANIONSHIP],
  [SOLUTION_HOME_CARE]: [FACILITY_HOME_CARE],
  [SOLUTION_HOSPICE_ASSOCIATION]: [FACILITY_HOSPICE_ASSOCIATION],
  [SOLUTION_HOSPICE_MOBILE]: [FACILITY_HOSPICE_MOBILE],
  [SOLUTION_HOSPICE_PARTIALLY_MOBILE]: [FACILITY_HOSPICE_PARTIALLY_MOBILE],
  [SOLUTION_HOSPICE_STATIC]: [FACILITY_HOSPICE_STATIC],
  [SOLUTION_INTENSIVE_PSYCHIATRIC_CARE_HOME]: [
    FACILITY_INTENSIVE_PSYCHIATRIC_CARE_HOME,
  ],
  [SOLUTION_LONGTERM_PSYCHIATRIC_CARE]: [FACILITY_LONGTERM_PSYCHIATRIC_CARE],
  [SOLUTION_MEDICAL_OCCUPATIONAL_REHAB]: [FACILITY_MEDICAL_OCCUPATIONAL_REHAB],
  [SOLUTION_MEDICAL_SUPPLIES]: [FACILITY_MEDICAL_SUPPLIES],
  [SOLUTION_MOBILE_CARE]: [FACILITY_MOBILE_CARE],
  [SOLUTION_NIGHT_CARE_MOBILE]: [FACILITY_NIGHT_CARE_MOBILE],
  [SOLUTION_NIGHT_CARE_STATIC]: [FACILITY_NIGHT_CARE_STATIC],
  [SOLUTION_PSYCHIATRIC_DAY_CLINIC]: [FACILITY_PSYCHIATRIC_DAY_CLINIC],
  [SOLUTION_REHAB_DAY_HOSPITALIZATION]: [FACILITY_REHAB_DAY_HOSPITALIZATION],
  [SOLUTION_REHAB_FULL_HOSPITALIZATION]: [FACILITY_REHAB_FULL_HOSPITALIZATION],
  [SOLUTION_REHAB_MOBILE]: [FACILITY_REHAB_MOBILE],
  [SOLUTION_SHARED_FLAT]: [FACILITY_SHARED_FLAT],
  [SOLUTION_SHORT_TERM_CARE_PSYCHIATRIC]: [FACILITY_SHORT_TERM_CARE_PSYCHIATRIC],
  [SOLUTION_SHORT_TERM_STATIC_CARE]: [FACILITY_SHORT_TERM_CARE],
  [SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_ADDICTIONS]: [
    FACILITY_SPECIAL_LIVING_ARRANGEMENTS_ADDICTIONS,
  ],
  [SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_INTELLECTUAL]: [
    FACILITY_SPECIAL_LIVING_ARRANGEMENTS_INTELLECTUAL,
  ],
  [SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_PSYCHIATRIC]: [
    FACILITY_SPECIAL_LIVING_ARRANGEMENTS_PSYCHIATRIC,
  ],
  [SOLUTION_STATIC_CARE]: [FACILITY_STATIC_CARE],
  [SOLUTION_STATIONARY_PSYCHIATRIC_REHAB]: [
    FACILITY_STATIONARY_PSYCHIATRIC_REHAB,
  ],
  [SOLUTION_WFBM]: [FACILITY_WFBM],
};

export function facilityToSolution(facility: number): number {
  const mappedSolution =
    Object.entries(solutionFacilitiesMap).find(([, facilities]) =>
      facilities.includes(facility),
    ) || [];
  return parseInt(mappedSolution[0] || "");
}

function solutionToFacilities(solution: number): Array<number> {
  return solutionFacilitiesMap[solution] || [];
}

export function solutionsToFacilities(solutions: Array<number>): Array<number> {
  return Array.from(
    new Set(solutions.flatMap((solution) => solutionToFacilities(solution))),
  );
}

export function isMobile(solution: number | null | undefined): boolean {
  return (
    solution === SOLUTION_MOBILE_CARE ||
    solution === SOLUTION_FULL_TIME_MOBILE_CARE ||
    solution === SOLUTION_HELP_AT_HOME
  );
}

export function hasMobile(solutions: number[] | null | undefined): boolean {
  return !!solutions?.some(isMobile);
}

export const filterSolutionsByMigrationFlag = (
  solutions: number[],
): number[] => {
  if (!activateSolutionToServiceMigration) {
    return solutions;
  }

  return solutions.filter(
    (solution) => solution !== SOLUTION_NIGHT_CARE_MOBILE,
  );
};
